export function Settings(settings) {
    let self = this;

    this.settings = {};

    this.defaultSettings = {
        paths: {
            baseApiUrl: process.env.PATH_API,
            assets: process.env.PATH_ASSETS,
        },
    };

    self.getSetting = function(name) {
        return _.get(this.settings, name);
    };

    //Gets all available settings
    self.getSettings = function() {
        let res = [];
        res.push("");
        for (let key in this.settings) {
            res.push(key);
        }
        res.sort();
        return res;
    };

    this.settings = deepmerge(this.defaultSettings, settings);
}


// WEBPACK FOOTER //
// ./src/utils/settings.js